<template>
  <div :class="className" :id="id" :style="{ height: height, width: width }" />
</template>

<script>
export default {
  name: "pingceCiyun",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "200px"
    },
    chartData: {
      type: Object
    },
    center: {
      type: Array
    }
  },
  data() {
    return {
      chart: null
      // map: null
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
       this.chart = this.$echarts.init(document.getElementById(this.id));
      let defaultText = [
        "值得",
        "漂亮",
        "方便",
        "经典",
        "一般",
        "值得",
        "漂亮",
        "方便",
        "经典",
        "一般",
        "值得",
        "漂亮",
        "方便",
        "经典",
        "一般",
        "值得",
        "漂亮",
        "方便",
        "经典",
        "一般",
        "值得",
        "漂亮",
        "方便",
        "经典",
        "一般",
        "值得",
        "漂亮",
        "方便",
        "经典"
      ];
      // let text = ['Sam S Club','Macys','Amy Schumer','Jurassic World','Charter Communications','Chick Fil A','Planet Fitness','Pitch Perfect','Express','Home','Johnny Depp','Lena Dunham','Lewis Hamilton','KXAN','Mary Ellen Mark','Farrah Abraham','Rita Ora','Serena Williams','NCAA baseball tournament','Point Break']
      let data = [];
      var text = "";
      // console.log("this.chartData", this.chartData);
      //     if (this.chartData == null) {
      //   text = defaultText;
      //
      // } else {
      //
      // }
        text = this.chartData.text;
       for (var i = 0; i < text.length; i++) {
        let obj = {};
        obj.name = text[i];
        obj.value = Math.random() * 160;
        // obj.value = 0 ;

        data.push(obj);
      }
      var _self = this
      console.log(data);
      let option = {
        // title: {
        //     text: 'Google Trends',
        //     link: ''
        // },
        tooltip: {
          show: false
        },
        series: [
          {
            type: "wordCloud",

            rotationRange: [0, 90], //数据翻转范围
            rotationStep: 90,
            sizeRange: [12, 15],
            textPadding: 0,
            autoSize: {
              enable: true,
              minSize: 6
            },
            textStyle: {
              //文字样式设置
              normal: {
                // fontSize: "2",
                color: function() {
                  var colors = _self.chartData.colorList;
                  return colors[parseInt(Math.random() * 5)];
                }
              }
            },
            data: data
          }
        ]
      };

      this.chart.setOption(option);
    }
  },
  watch: {
    //   center: function() {
    //     //this.chart.dispose();
    //     //this.chart = null;
    //      this.initChart();
    //   }
  }
};
</script>
<style scoped lang="less"></style>
